import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  InputHTMLAttributes,
} from 'react';

import { useField } from '@unform/core';
import Checkbox from '../../../../components/Exame/CheckBox';
import { Container, ContentPrincipal } from './styles';
import { PERMISSAO_INDIVIDUAL, arrayGroupBy } from '../../../../utils/funcoes';

interface ICheck {
  name: string;
  key: string;
  label: string;
  checked?: boolean;
}

interface DivProps extends InputHTMLAttributes<HTMLDivElement> {
  name: string;
  permissoes: string;
}

export interface IProcedimentos {
  ProCodigo: number;
  ProNome: string;
  perfil: {
    PerCodigo: number;
    PerNome: string;
  };
}

interface IOptions {
  value: string;
  label: string;
  isDisabled?: boolean;
}

const CheckboxContainer: React.FC<DivProps> = ({
  name,
  permissoes,
  ...rest
}) => {
  const checkRef = useRef(null);
  const { fieldName, registerField } = useField(name);
  const [checkedItems, setCheckedItems] = useState<string>('');
  const [itens, setItens] = useState<ICheck[]>([]);

  useEffect(() => {
    function load(): void {
      setItens([]);

      const options = Object.keys(PERMISSAO_INDIVIDUAL).map(key => ({
        value: key,
        label: PERMISSAO_INDIVIDUAL[key] ?? '',
        name: key,
        key,
      }));

      const selecionados = options.map(it => {
        return {
          name: it.name,
          label: it.label,
          key: it.key,
          checked: permissoes?.split(',')?.indexOf(it.key) !== -1,
        };
      });
      setItens(selecionados);

      const its = selecionados
        .filter(item => {
          return item.checked;
        })
        .map(i => i.key)
        .join(',');

      setCheckedItems(its);
    }

    if (PERMISSAO_INDIVIDUAL && permissoes) load();
  }, [PERMISSAO_INDIVIDUAL, permissoes]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: checkRef.current,
      path: 'value',
      clearValue: ref => {
        ref.clear();
      },
      setValue: (ref, valord) => {
        // setCheckedItems(valord);
      },
    });
  }, [checkedItems, fieldName, registerField, itens]);

  const handleChange = useCallback(
    e => {
      const nomePermissao = e.target.name;
      const isChecked = e.target.checked;

      const newItens = itens.map(item => {
        if (item.name === nomePermissao) return { ...item, checked: isChecked };
        return item;
      });

      const its = newItens
        .filter(item => {
          return item.checked;
        })
        .map(i => i.key)
        .join(',');

      setCheckedItems(its);

      setItens(newItens);
    },
    [itens],
  );

  return (
    <>
      <div>
        <ContentPrincipal>
          <input
            className="d-none"
            value={checkedItems}
            onChange={() => console.log(itens)}
            ref={checkRef}
          />
          {itens.map(item => (
            <Container key={item.key}>
              <Checkbox
                name={item.name}
                checked={item.checked}
                onChange={handleChange}
              />
              <label htmlFor={item.name}>{item.label}</label>
            </Container>
          ))}
        </ContentPrincipal>
      </div>
    </>
  );
};

export default CheckboxContainer;
